// Dont change the order of the imports because of circular dependencies
import { createRoot } from "react-dom/client";
import App from "./main/common/components/App";
import Firebase from "./main/common/firebase/firebase";
import countries from "i18n-iso-countries";
import germanCountryNames from "i18n-iso-countries/langs/de.json";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { setupIonicReact } from "@ionic/react";
import { setupErrorBoundary } from "./configuration/setupBugsnag";
import { setupInvoiceApi } from "./configuration/setupInvoiceApi";
import { setupMailApi } from "./configuration/setupMailApi";
import { setupTrackerApi } from "./configuration/setupTrackerApi";
import { setupNotificationApi } from "./configuration/setupNotificationApi";
import { environment } from "./main/config/config";
import "./polyfills";
import { setupDatevApi } from "./configuration/setupDatevApi";
import { isPlatform } from "@ionic/core";

Firebase.initialize({ runningInEmulator: environment === "local", runningInTests: false });
setupIonicReact({
    swipeBackEnabled: false,
    innerHTMLTemplatesEnabled: true,
    platform: {
        /** The default `mobile` function returns true for everything with a touchscreen.
         * We do not want that because then monitors or notebooks with touchscreens are classified as mobile.
         **/
        mobile: () => {
            return isPlatform("ios") || isPlatform("android");
        },
    },
});
setupInvoiceApi();
setupMailApi();
setupTrackerApi();
setupDatevApi();
setupNotificationApi();
countries.registerLocale(germanCountryNames);

const ErrorBoundary = setupErrorBoundary();

const container = document.getElementById("root") as Element;
const root = createRoot(container);
root.render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
);

defineCustomElements(window);

declare global {
    interface Window {
        hsConversationsSettings: Record<string, any>;
        hsConversationsOnReady: Array<() => void>;
        HubSpotConversations: {
            on: any;
            off: any;
            widget: {
                status: () => { loaded: boolean; pending: boolean };
                load: (params?: { widgetOpen: boolean }) => void;
                remove: () => void;
                open: () => void;
                close: () => void;
                refresh: (parameters?: { openToNewThread: boolean }) => void;
            };
        };
        disableBugsnag?: boolean;
    }
}
